import {
    defaultSelectedProduct, product_combo
} from './state';
import {getApiDomain} from '../../util/domains';

// trae todos los productos
export function setStateProducts(state, products) {
    state.products = products;
}

// Guardar los data sheets
export function setProductsDataSheets(state, data_sheets) {
    let subscriber = JSON.parse(localStorage.getItem("subscriber"));

    //Para ventas instituvionales en portal clientes mostrar solo Peso y Refrigerado
    if (subscriber.identification === '800198348' && state.data_sheets_from_b2b){
        state.data_sheets = data_sheets.filter(item =>
            ['PESO','REFRIGERADO'].includes(item.data_sheet_detail.internal_name)
        );
    }else{
        state.data_sheets = data_sheets;
    }

}

// trae al estate un solo producto
export function setProduct(state, product) {
    product.subcategory_id_1 = product.subcategory_id;
    state.selectedProduct = product;
    let proovedor = state.providers.find(prov => prov.id === state.selectedProduct.provider )
    if ((!proovedor || !state.providers.length) && state.selectedProduct.provider_contact ){
        state.providers.push(state.selectedProduct.provider_contact)
    }
    if (product.inventory){
        state.inventory = product.inventory
    }else{
        state.inventory = {
            branchoffice_warehouse_id : Number(localStorage.getItem("selected_branchoffice_warehouse")),
            product_id :null,
            minimum_stock :'',
            maximum_stock :'',
            location :'',
        }
    }
}

//Obtener clasificaciones de rotacion
export function setClassification(state, classification) {
    state.selectedClassification = classification;
}

export function setProductsAttachments(state, products_attachments) {
    products_attachments.map(pa => {
        const encodedSrc = encodeURI(pa.src).replace(/#/g, '%23');
        const encodedThump = encodeURI(pa.thumb).replace(/#/g, '%23');

        pa.src = getApiDomain() + encodedSrc;
        pa.thumb = getApiDomain() + encodedThump;
    });
    state.products_attachments = products_attachments;
}

export function setparameters_status(state, parameters_status) {
    state.parameters_status = parameters_status;
}

export function setAction(state, action) {
    state.action = action;
}

export function productError(state, error) {
    state.error = true;
    state.errorMessage = error;
    state.products = [];
}

export function setGetProductEdit(state, getProductEdit) {
    state.getProductEdit = getProductEdit;
}

//Establece el valor por defecto de selectedLine
export function resetSelectedProduct(state) {
    let id = state.selectedProduct.id;
    Object.assign(state.selectedProduct, defaultSelectedProduct());
    state.products_attachments = [];
    //state.selectedProduct.id = id;
    state.price = {
        price_list_id: null,
        price: 0,
        product_id: null
    }
    state.inventory = {
        branchoffice_warehouse_id : Number(localStorage.getItem("selected_branchoffice_warehouse")),
        product_id :null,
        minimum_stock :'',
        maximum_stock :'',
        location :'',
    }
}

export function setLines(state, lines) {
    state.lines = lines;
}

export function setImagenCarga(state, image) {
    state.selectedProduct.products_attachments.url = image;
}

export function setDocumentPath(state, data_sheet) {
    state.selectedProduct.products_technnical_data.link_data_sheet = data_sheet;
}

export function setSublines(state, sublines) {

    if (sublines.length <= 0) {
        return;
    }

    state.sublines = sublines.map(p => {
        return {
            value: p.id,
            label: `${p.subline_code} - ${p.subline_description}`
        };
    });
}

export function setBrands(state, brands) {

    if (brands.length <= 0) {
        return;
    }

    state.brands = brands.map(p => {
        return {
            value: p.id,
            label: p.description
        };
    });
}

export function setSubbrands(state, subbrands) {
    state.subbrands = subbrands.map(p => {
        return {
            value: p.id,
            label: p.description
        };
    });
}

export function setCategories(state, categories) {
    state.categories = categories.map(p => {
        return {
            value: p.id,
            label: p.categorie_code + ' - ' + p.description
        };
    });

    let cat_ = state.categories.find(el => el.value === state.selectedProduct.category_id);
    if (!cat_){
        state.selectedProduct.category_id = null;
    }
}

export function setSubcategoriesMutation(state, subcategories) {
    state.subcategories = subcategories.map(p => {
        return {
            value: p.id,
            label: p.subcategorie_code + ' - ' + p.description
        };
    });

    let subcat_ = state.subcategories.find(el => el.value === state.selectedProduct.subcategory_id);
    if (!subcat_){
        state.selectedProduct.subcategory_id = null;
    }
}

// Establece un valor para tipo de producto
export function setProductType(state, productType) {
    state.productType = productType;
}

// Establece un valor para Talla
export function setSize(state, size) {
    state.size = size;
}

export function setColor(state, color) {
    state.color = color;
}

// Establece un valor para taxpayerTypes
export function setRotationType(state, rotationType) {
    state.rotationType = rotationType;
}

// Establece un valor para taxRegimes
export function setApplicationUnit(state, applicationUnit) {
    state.applicationUnit = applicationUnit;
}

export function setFilterBranch(state, branch) {
    state.search_params.branch = branch;
}

export function setParams(state, new_params) {

    let params = JSON.parse(JSON.stringify(state.params));

    for (let np in new_params) {
        let add = false;
        for (let p in params) {
            if (p == np) {
                params[p] = new_params[np];
                add = true;
            }
        }

        if (!add) {
            params[np] = new_params[np];
        }
    }

    state.params = params;
}

export function setErrorFileImport(state, data) {
    state.errorFileImport = data;
}

export function setChangeStateLoadFile(state, data) {
    state.loadFileImport = data;
}

export function clearDataSheets(state) {
    state.data_sheets = [];
}


/*
 * Estos mutadores se encargar de normalizar la informacion
 * para mostrar en la tabla de productos.
 *
 * @author Kevin Galindo
 */

export function setProductsTable(state, data) {
    //console.log(data.data);
    // Agregamos los datos de la tabla
    state.tableProduct.data = data.data;

    // Quitamos los valores de la tabla del arreglo
    delete data.data;

    // Agregamos los datos de la paginacion
    state.tableProduct.pagination = data;
}

export function setParametersTableInRow(state, data) {
    state.data_sheets.map((ds, index) => {
        if (ds.data_sheet_id == data.row.data_sheet_id) {
            state.data_sheets[index].data_sheet_detail.parameters = data.data;
            state.data_sheets[index].data_sheet_detail.paramtable_id = data.paramtable_id;
        }
    });
}

export function setbranchoffice_warehouse_id(state, warehouse_id) {
    state.params.branchoffice_warehouse_id = warehouse_id;
}

export function setBranchoffice(state, branchoffice) {
    state.params.branchoffice = branchoffice;
}

export function setContactIdParams(state, contact_id) {
    state.params.contact_id = contact_id;
}

export function setProviders(state, providers) {
    state.providers = providers;
    let proovedor = state.providers.find(prov => prov.id === state.selectedProduct.provider )
    if ((!proovedor || !state.providers.length) && state.selectedProduct.provider_contact ){
        state.providers.push(state.selectedProduct.provider_contact)
    }
}

export function setRotationClassification(state, rotationclassification) {
    state.rotationclassification = rotationclassification;
}

export function setPackingUnits(state, packing_units) {
    state.packing_units = packing_units;
}
export function setImagesFiles(state, images) {
    state.loadImages.images = images;
    state.loadImages.totalCuantity = images.length;
    state.loadImages.loadedQuantity = 0;
    state.loadImages.processedQuantity = 0;

    //Errors
    state.loadImages.errors.has = false;
    state.loadImages.errors.message = '';
    state.loadImages.errors.data = [];
}

export function resetImagesFiles(state) {
    state.loadImages.images = [];
    state.loadImages.totalCuantity = 0;
    state.loadImages.loadedQuantity = 0;
    state.loadImages.processedQuantity = 0;

    //Errors
    state.loadImages.errors.has = false;
    state.loadImages.errors.message = '';
    state.loadImages.errors.data = [];
}

/**
 * Establecer un valor para la variable modal_combos.
 */
export function setModalCombos(state, modal_combos) {
    state.modal_combos = modal_combos;
}

/**
 * Establecer un valor para la variable products_combo.
 */
export function setProductsCombo(state, products_combo) {
    state.products_combo = products_combo;
}

/**
 * Establecer un valor para la variable product_combo.
 */
export function setProductCombo(state, product_combo) {
    state.product_combo = product_combo;
}

/**
 * Establecer el valor por defecto de la variable product_combo.
 */
export function resetProductCombo(state) {
    state.product_combo = product_combo();
}

/**
 * Establecer un valor para el atributo show de la variable modal_combos.
 */
export function setShowToModalCombos(state, show) {
    state.product_combo = product_combo();
    state.modal_combos.show = show;
}

/**
 * Establecer un valor para la variable types.
 */
export function setTypes(state, types) {
    state.types = types;
}

/**
 * Establecer un valor para la variable generic_products.
 */
export function setGenericProducts(state, generic_products) {
    state.generic_products = generic_products;
}

/**
 * Establecer un valor para la variable price_lists.
 */
export function setPriceLists(state, price_lists) {
    state.price_lists = price_lists;

    const general_price_list = price_lists.find(pl => pl.code_parameter === '001');

    if (general_price_list) {
        state.price.price_list_id = general_price_list.id;
    }
}

/**
 * Establecer un valor para la variable price.
 */
export function setPrice(state, price) {
    state.price = price;
}

export function setBranchsWarehouses(state,branchsWare){
    state.branchsWare = branchsWare.map(item =>{
        return {
            label: `${item.branchoffice ? item.branchoffice.name : ''} - ${item.warehouse_description}`,
            id: item.id
        }

    });
}
/**
 * Establecer un valor para la variable inventory.
 */
export function setProductInventory(state,inventory){
    state.inventory =  inventory
}
/**
 * Establecer un valor para la variable preloader.
 */
export function setLoader(state,loader){
    state.preloader = loader;
}

export function setAudit(state,data) {
    state.auditProduct = data;
}

/**
 * Establecer un valor por defecto para la variable inventory.
 */
export function setInventoryDefault(state){
    state.inventory = {
        branchoffice_warehouse_id : Number(localStorage.getItem("selected_branchoffice_warehouse")),
        product_id :null,
        minimum_stock :'',
        maximum_stock :'',
        location :'',
    }
}
/**
 * Establece valor en la variable parameter_rotation_classification
 */
export function setParametersRotationClassification(state, parameters){
    state.parameter_rotation_classification = parameters;
}

export function setDataSheetsFromB2b(state, bool){
    state.data_sheets_from_b2b = bool
}

/**
 * Establecer un valor para la variable subscriber.
 */
export function setSubscriber(state, subscriber) {
    state.subscriber = subscriber;
}

/**
 * Establecer un valor para la variable code.
 */
export function setCodeProduct(state, data) {
    state.selectedProduct.code = parseInt(data)+1;
}


export function setVehicleBrands(state, data) {
    state.vehicleBrands = data;
}

export function setVehicleModels(state, data) {
    state.vehicleModels = data;
}

export function setVehicleYears(state, data) {
    state.vehicleYears = data;
}

export function setVehicleEngineDisplacements(state, data) {
    state.vehicleEngineDisplacements = data;
}

export function setVehicleTransmissions(state, data) {
    state.vehicleTransmissions = data;
}

export function setProductVehicles(state, payload) {
    state.productVehicles = payload;
}

export function setInheritVehiclesProducts(state, payload) {
    state.inheritVehiclesProducts = payload;
}

export function setProductInheritVehicles(state, payload) {
    state.productInheritVehiclesList = payload;
}

export function resetProductVehiclesData(state) {
    state.inheritVehiclesProducts = [];
    state.productInheritVehiclesList = [];
    state.productVehicles = [];
}


// WEBPACK FOOTER //
// ./src/modules/products/mutations.js